import { render } from "./random.vue?vue&type=template&id=60160a4a"
import script from "./random.vue?vue&type=script&lang=js"
export * from "./random.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__